import { render } from "./FundTransfer.vue?vue&type=template&id=1f9d5e63"
import script from "./FundTransfer.vue?vue&type=script&lang=js"
export * from "./FundTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__